import { render, staticRenderFns } from "./LivroRazaoReport.vue?vue&type=template&id=c35f41d6"
import script from "./LivroRazaoReport.vue?vue&type=script&lang=js"
export * from "./LivroRazaoReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports